import axios from 'axios'
import Utils from '@/common/Utils'

const headers = { 'Content-Type': 'application/json' }
const baseUrl = `${process.env.VUE_APP_HOST || ''}/clients`

export default class ClientsManagerService {
    static async getOne (endpoint, id, params = {}) {
        try {
            headers['Authorization'] = await Utils.setClientsManagerToken()
            let { data } = await axios.get(`${baseUrl}${endpoint}${id}`, { headers, params, withCredentials: false })
            return data
        } catch (error) {
            throw error.response
        }
    }

    static async getAll (endpoint, params = {}) {
        try {
            headers['Authorization'] = await Utils.setClientsManagerToken()
            let { data } = await axios.get(`${baseUrl}${endpoint}`, { headers, params, withCredentials: false })
            return data.data ? data.data : data
        } catch (error) {
            throw error.response
        }
    }
}
